import clsx from 'clsx'
import React, { CSSProperties, HTMLAttributes } from 'react'

import s from './styles.module.scss'

export interface HelperTextProps extends HTMLAttributes<HTMLParagraphElement> {
  type: 'error' | 'success'
  message: string
  style?: CSSProperties
}
export const HelperText = ({
  message,
  type,
  style,
  ...rest
}: HelperTextProps) => {
  return (
    <p className={clsx(s.text, s[type])} style={style} {...rest}>
      {message}
    </p>
  )
}
